import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserService } from 'services';
import { User } from 'models';

@Injectable({
    providedIn: 'root'
})
export class UserResolver implements Resolve<User> {
    constructor(private userService: UserService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        return this.userService.user$.pipe(take(1));
    }
}
